import { Box, Globe, GitBranch, Zap, Timer } from "lucide-react";

/** Renders the provider's icon when available, falling back to a built-in icon by node type. */
export function renderNodeIcon(nodeType: string, className?: string, iconUrl?: string | null) {
  if (iconUrl) {
    return <img src={iconUrl} alt="" className={`${className ?? ""} object-contain`} />;
  }

  switch (nodeType) {
    case "HttpRequest":
      return <Globe className={className} />;
    case "Switch":
      return <GitBranch className={className} />;
    case "InvokeWorkflow":
      return <Zap className={className} />;
    case "Delay":
      return <Timer className={className} />;
    default:
      return <Box className={className} />;
  }
}

export function getNodeSolidColor(nodeType: string): { bg: string; shadow: string; text: string } {
  switch (nodeType) {
    case "HttpRequest":
      return { bg: "bg-blue-500", shadow: "shadow-blue-500/30", text: "text-blue-500" };
    case "Switch":
      return { bg: "bg-amber-500", shadow: "shadow-amber-500/30", text: "text-amber-500" };
    case "InvokeWorkflow":
      return { bg: "bg-violet-500", shadow: "shadow-violet-500/30", text: "text-violet-500" };
    case "Delay":
      return { bg: "bg-teal-500", shadow: "shadow-teal-500/30", text: "text-teal-500" };
    default:
      return { bg: "bg-[#0071e3]", shadow: "shadow-[#0071e3]/30", text: "text-[#0071e3]" };
  }
}
